import { breakpoint } from '../../util/helpers';
import { setParentInert } from '../../util/a11y/handle-inert';
import { debounce } from '../../util/helpers';

export default {
  init() {
    const sharer = document.querySelector('.ms-sharer');

    if (!sharer) return;

    const wrapper = sharer.querySelector('.ms-sharer__wrapper');
    const btns = sharer.querySelectorAll('.ms-sharer__btn');
    const btn = sharer.querySelector('button');
    const sharerLabel = sharer.querySelector('.ms-sharer__share-label');
    const listWrapper = sharer.querySelector('.ms-sharer__wrapper__list')
    const list = sharer.querySelector('.ms-sharer__list')

    const resizeWrapper = () => {
      wrapper.style.removeProperty('height');
      if (breakpoint() === 'mobile') return;
      const lineWidths = { desktop: 100, tablet: 80 };
      const lineWidth = lineWidths[breakpoint()];
      wrapper.style.height = `${wrapper.getBoundingClientRect().height + sharerLabel.firstElementChild.getBoundingClientRect().height + lineWidth}px`;
    }

    window.addEventListener('resize', debounce(() => {
      resizeWrapper();
    }), 1000);

    btn.addEventListener('click', () => {
      sharer.classList.toggle('ms-sharer--open');

      if (breakpoint() === 'mobile') {
        if (sharer.classList.contains('ms-sharer--open')) {
          listWrapper.style.height = `${list.getBoundingClientRect().height}px`;
        } else {
          listWrapper.style.height = '0px';
        }
      }

      this.inertHandler(sharer, btn);
    });

    this.eventHandler();
    this.endPointHandler(sharer);
    this.inertHandler(sharer, btn);

    /* Close the sharer upon clicking outside */
    document.addEventListener('click', ({ target }) => {
      if (target !== btn) {
        btns.forEach(btn => {
          const parent = btn.parentElement;
          const type = btn.dataset.type;
          if (type === 'link') {
            parent.classList.remove('ms-show-tooltip');
          }
        });
        sharer.classList.remove('ms-sharer--open');
      }
    });

    /* Close the sharer upon resizing the window */
    window.addEventListener('resize', () => {
      sharer.classList.remove('ms-sharer--open');
      this.inertHandler(sharer, btn);
    });

    // get facebook id via ajax
    window.fbAsyncInit = () => {
      fetch(window.msAjax.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
        body: 'action=fetch_facebook_id'})
        .then(resp => resp.json())
        .then(({ fb_id }) => {
          if (!fb_id) { console.error('Please provide the Facebook App ID in the CMS.'); return; }

          window.FB.init({
            appId      : fb_id,
            status     : true,
            xfbml      : true,
            version    : 'v2.7',
          });

        }).catch(() => {
          console.error('Please provide the Facebook App ID in the CMS.');
        });
    }

    setTimeout(() => {
      resizeWrapper();
    }, 1000);
  },

  eventHandler() {
    const sharer = document.querySelector('.ms-sharer');
    const btns = sharer.querySelectorAll('.ms-sharer__btn');
    let tooltipResetId = 0;

    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const type = btn.dataset.type;

        if (type === 'link') {
          clearTimeout(tooltipResetId);
          const temp = document.createElement('input');
          const url = window.location.href;
          const parent = btn.parentElement;
          document.body.appendChild(temp);
          temp.value = url;
          temp.select();
          temp.setSelectionRange(0, 99999); /*For mobile devices*/
          document.execCommand('copy');
          temp.remove();

          // Show tooltip
          parent.classList.add('ms-show-tooltip');

          // Remove the tooltip after 2seconds
          tooltipResetId = setTimeout(() => {
            parent.classList.remove('ms-show-tooltip');
          }, 2000);
        } else if (type === 'facebook') {
          window.FB.ui({
            method: 'share',
            href: window.location.href,
          });
        } else if (type === 'twitter') {
          window.open(
            `http://twitter.com/share?text=${btn.dataset.title} — @windsorsalt&url=${window.location.href}`,
            'Share to Twitter',
            'scrollbars=no,resizable=no,status=no,location=no,menubar=no,top=50,left=50,width=800,height=448'
          );
        } else if (type === 'pinterest') {
          window.open(
            `http://pinterest.com/pin/create/button/?url=${window.location.href}&description=${btn.dataset.title}`,
            'Share to Pinterest',
            'scrollbars=no,resizable=no,status=no,location=no,menubar=no,top=50,left=50,width=800,height=448'
          );
        }
      })
    });
  },

  endPointHandler(sharer) {
    const container = sharer.parentElement;
    const nextElement = container.nextElementSibling;

    const buildThresholdList = () => {
      let thresholds = [];
      let numSteps = 100;

      for (let i=1.0; i<=numSteps; i++) {
        let ratio = i/numSteps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    }

    const options = {
      root: null,
      rootMargin: '0px 0px 100px',
      threshold: buildThresholdList(),
    }

    const observeIntersection = entries => {
      entries.forEach((entry) => {
        const { intersectionRatio, boundingClientRect } = entry;
        /* Track the position of the intersecting element */
        if (intersectionRatio === 0) {
          if (boundingClientRect.top > window.innerHeight) {
            sharer.classList.remove('ms-sharer--reached-endpoint'); // outside bottom
          } else {
            sharer.classList.add('ms-sharer--reached-endpoint'); // outside top
          }
        } else if (intersectionRatio > 0.1 && intersectionRatio <= 1) {
          if (boundingClientRect.top < (window.innerHeight / 3)) {
            sharer.classList.add('ms-sharer--reached-endpoint'); // top
          } else if (boundingClientRect.top > (window.innerHeight - (window.innerHeight / 3))) {
            sharer.classList.add('ms-sharer--reached-endpoint'); // bottom
          } else {
            sharer.classList.add('ms-sharer--reached-endpoint'); // center
          }
        }
      });
    }

    const nextElementObserver = new IntersectionObserver(observeIntersection, options);

    if (nextElement) {
      nextElementObserver.observe(nextElement);
    } else {
      nextElementObserver.observe(document.querySelector('footer'));
    }
  },

  inertHandler(sharer, btn) {
    const list = sharer.querySelector('.ms-sharer__list');

    if (breakpoint() === 'mobile') {
      if (sharer.classList.contains('ms-sharer--open')) {
        btn.setAttribute('aria-expanded', 'expanded');
        setParentInert(false, list);
      } else {
        btn.setAttribute('aria-expanded', 'collapsed');
        setParentInert(true, list);
      }
    } else {
      setParentInert(false, list);
    }
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/components/sharer.js